export default __webpack_public_path__ + "static/media/rain.8f71914c.mp4";